import { helpers, ts } from '_core';

export const prepareCovariancesChart = (
  data: ts.types.widgets.TableData,
  signals: ts.types.signal.AlphaSignalEnhanced[]
) => {
  const alphaModelName = 'Alpha Model';
  const varNames = helpers.buildName.signalVarNameUniq(signals);

  // First, map the data to include proper names
  const mappedData = data.map((row) => {
    const varName1 = varNames[Number((row.factor_x as string).replace('var', ''))] ?? alphaModelName;
    const varName2 = varNames[Number((row.factor_y as string).replace('var', ''))] ?? alphaModelName;
    return {
      ...row,
      factor_x: varName1,
      factor_y: varName2,
    };
  });

  // Create an ordered list with Alpha Model first, followed by signals in their original order
  const orderedLabels = [alphaModelName, ...varNames];

  return mappedData.sort((a, b) => {
    // Get the position of each factor in our ordered list
    const aXIndex = orderedLabels.indexOf(a.factor_x);
    const aYIndex = orderedLabels.indexOf(a.factor_y);
    const bXIndex = orderedLabels.indexOf(b.factor_x);
    const bYIndex = orderedLabels.indexOf(b.factor_y);

    // Sort by X factor first
    if (aXIndex !== bXIndex) {
      return aXIndex - bXIndex;
    }

    // If X factors are the same, sort by Y factor
    return aYIndex - bYIndex;
  });
};
